import { render } from "./VenueIntroduction.vue?vue&type=template&id=07728d82"
import script from "./VenueIntroduction.js?vue&type=script&lang=js"
export * from "./VenueIntroduction.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__